import React, { memo } from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import {FormBlocks} from './FormBlocks';
import {formFieldsAttributes} from '../../FormBuilderFunctions/FieldProps';

const MultiSelect = (props)=>{
  
  const  {
    item,
    isMulti,
    className,
    validationForms,
    fieldObj
  } = props;
  const animatedComponents = makeAnimated();
  const options =  item.options;
  
  const attr = formFieldsAttributes(
    {...item,className:className
  },validationForms);

  let value = attr.value;
  let defaultValueOptions = [];
  options.map((item)=>{
      if(value.split(',').indexOf(item.value)!== -1 || value.split(',').indexOf(item.id)!== -1){ 
        item.checked=true;
        defaultValueOptions.push(item);
      }
  })
  return (
    <FormBlocks {...props}  attr={attr}>
      <div className={item.required===true ? "mandatory" : "" } style={{width:'100%'}}>
        <Select 
          isMulti={isMulti}
          classNamePrefix="form-control"
          options={options.map((item,index)=>{
            item.label = item.value;
            item.index = index;
            return item;
          })}
          onChange={e => props.onChangeInputAction(fieldObj,e,'MultiSelect')}
          value={defaultValueOptions}
          components={animatedComponents}
          {...attr.fieldAttributes}  />
      </div>
    </FormBlocks>
  );
}

MultiSelect.defaultProps = {
  isMulti: true,
  className:''
}

const isDiffProps = (prevProps,nextProps)=>{
  if(prevProps.item.selectedValue===nextProps.item.selectedValue && prevProps.validationForms===nextProps.validationForms && prevProps.item.access_mode===nextProps.item.access_mode && prevProps.item.required===nextProps.item.required){
    return true;
  }
}


export default memo(MultiSelect,isDiffProps);
